"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tabsStyles = void 0;

var _styledComponents = require("styled-components");

var _getColor = require("../styleHelpers/getColor");

var _getSpacing = require("../styleHelpers/getSpacing");

var _styleHelpers = require("../styleHelpers");

var tabsStyles = {
  gap: (0, _getSpacing.getSpacing)(2),
  tab: {
    color: (0, _getColor.getColor)('common', 'black'),
    icon: {
      gap: (0, _styleHelpers.getComponentStyle)('button.base.icon.gap'),
      size: (0, _styleHelpers.getComponentStyle)('button.base.icon.size.medium')
    },
    padding: (0, _styledComponents.css)(["", " ", " ", ""], (0, _getSpacing.getSpacing)(4), (0, _getSpacing.getSpacing)(5), (0, _getSpacing.getSpacing)(5)),
    margin: (0, _styledComponents.css)(["0 0 ", ""], (0, _getSpacing.getSpacing)(0)),
    hover: {
      backgroundColor: (0, _styleHelpers.getComponentStyle)('button.brand.text.hover.backgroundColor')
    },
    focus: {
      outlineColor: (0, _styleHelpers.getComponentStyle)('button.brand.outlineColor')
    },
    active: {
      backgroundColor: (0, _styleHelpers.getComponentStyle)('button.brand.text.hover.backgroundColor')
    },
    selected: {
      padding: (0, _styledComponents.css)(["", " ", " ", ""], (0, _getSpacing.getSpacing)(4), (0, _getSpacing.getSpacing)(5), (0, _getSpacing.getSpacing)(5)),
      margin: '0',
      color: (0, _getColor.getColor)('brand'),
      bottomBorder: {
        color: (0, _getColor.getColor)('brand'),
        thickness: (0, _getSpacing.getSpacing)(2),
        gap: (0, _getSpacing.getSpacing)(4),
        radius: (0, _getSpacing.getSpacing)(2)
      }
    }
  }
};
exports.tabsStyles = tabsStyles;